import DPDropDown from "framework/components/DPDropDown"
import DPTextBoxforgrid from "framework/components/DPTextBoxforgrid"
import React, { useEffect, useState } from "react"
import { Col, Row, Button, Label } from "reactstrap"
import { AutoOrderCalculation, getLocationDropdown } from "./ProductController"


const ProductAutoOrderContent = ({
    HandleClearStatus,
    productCode,
    productDesc,
    costPrice,
    salesPrice,
    supplier,
    packSize,
    setAlertShow,
    setAlertColor,
    setAlertMsg
}) => {

    const [locations, setLocations] = useState([])
    const [selectedLocation, setSelectedLocation] = useState("")
    const [calculatedData, setCalculatedData] = useState({})
    const filteredOne = supplier.find((item) => item.state == true)
    const supplierName = filteredOne && filteredOne.desc ? filteredOne.desc : ""

    useEffect(() => {
        getLocationDropdown().then((res) => {
            setLocations(res)
        }).catch((err) => {
            console.log(err)
        })
    }, [])


    useEffect(() => {
        var obj = JSON.parse(localStorage.getItem("authUser"))
        var LocationCode = obj[3]
        setSelectedLocation(LocationCode)
        setCalculatedData({})
    }, [HandleClearStatus])


    function onClickCalculate() {

        if (selectedLocation === "") {
            setAlertShow(true)
            setAlertColor("danger")
            setAlertMsg("Please Select Location")
            setTimeout(() => {
                setAlertShow(false)
            }, 5000);
            return
        }

        if (productCode === "") {
            setAlertShow(true)
            setAlertColor("danger")
            setAlertMsg("Please Select Product")
            setTimeout(() => {
                setAlertShow(false)
            }, 5000);
            return
        }

        AutoOrderCalculation(productCode, selectedLocation).then((res) => {
            setCalculatedData(res)

        }).catch((err) => {
            console.log(err)
        })

    }


    return (
        <React.Fragment>
            <Row>
                <Col sm={12} md={6} className="mb-12-sm">
                    <TextBoxWithLabel
                        label={"Product"}
                        value={productCode} />
                    <TextBoxWithLabel
                        label={"Product Name"}
                        value={productDesc} />
                    <TextBoxWithLabel
                        label={"Cost Price"}
                        value={parseFloat(costPrice).toFixed(2)}
                        textAlign={"right"} />
                    <TextBoxWithLabel
                        label={"Sales Price"}
                        value={parseFloat(salesPrice).toFixed(2)}
                        textAlign={"right"} />
                    <TextBoxWithLabel
                        label={'Supplier'}
                        value={supplierName} />
                    <TextBoxWithLabel
                        label={"Pack Size"}
                        value={packSize}
                        textAlign={"right"} />
                </Col>

                {calculatedData?.orderQTY !== undefined ? <Col sm={12} md={3} className="mb-12-sm">
                    <Row style={{ justifyContent: 'center', fontSize: '18px' }}>Today Order Quantity</Row>
                    <Row style={{ justifyContent: 'center', fontSize: '28px' }}>{calculatedData?.orderQTY} </Row>
                </Col> : null}

                {calculatedData?.isTOP80 !== undefined ? <Col sm={12} md={3} className="mb-12-sm">
                    <Row style={{ justifyContent: 'center', fontSize: '28px', color: calculatedData?.isTOP80 == 1 ? 'green' : 'red' }}>{calculatedData?.isTOP80 == 1 ? 'Top 80' : 'Bottom 20'} </Row>
                    <Row style={{ justifyContent: 'center', fontSize: '18px' }}>Product</Row>
                </Col> : null}

            </Row>

            <Row className="mb-3 mt-3">
                <Col sm={12} md={6} className="mb-12-sm">
                    <Row className="mb-2">
                        <Col sm={12} md={3} className="mb-4-sm">
                            <Label>Location</Label>
                        </Col>
                        <Col sm={12} md={9} className="mb-4-sm">
                            <DPDropDown
                                selectedGroup={selectedLocation}
                                onChange={(e) => {
                                    setSelectedLocation((e["value"]))
                                }}
                                optionGroup={locations}
                                labelHide={true}
                                disabled={productCode != "" ? false : true}
                            />
                        </Col>
                    </Row>
                </Col>
                <Col sm={12} md={6} className="mb-12-sm">
                    <Button color="primary" className="btn-sm" disabled={productCode != "" ? false : true} onClick={onClickCalculate}>Calculate</Button>
                </Col>
            </Row>

            <Row>
                <Col sm={12} md={4} className="mb-12-sm">
                    <TextBoxWithLabel
                        label={"Lead Time Days"}
                        value={calculatedData?.lead_DAYS ? calculatedData?.lead_DAYS : 0}
                        labelsize={6}
                        boxsize={6}
                        textAlign={"right"} />
                    <TextBoxWithLabel
                        label={"QTY in Hand"}
                        labelsize={6}
                        value={calculatedData?.sih ? calculatedData?.sih : 0}
                        boxsize={6}
                        textAlign={"right"} />
                    <TextBoxWithLabel
                        label={"MBQ Days"}
                        value={calculatedData?.mbq_DAYS ? calculatedData?.mbq_DAYS : 0}
                        labelsize={6}
                        boxsize={6}
                        textAlign={"right"} />
                    <TextBoxWithLabel
                        label={"Display QTY"}
                        value={calculatedData?.disp_QTY ? calculatedData?.disp_QTY : 0}
                        labelsize={6}
                        boxsize={6}
                        textAlign={"right"} />

                </Col>
                <Col sm={12} md={4} className="mb-12-sm">
                    <TextBoxWithLabel
                        label={"Gondola QTY"}
                        value={calculatedData?.gondola_QTY ? calculatedData?.gondola_QTY : 0}
                        labelsize={6}
                        boxsize={6}
                        textAlign={"right"} />
                    <TextBoxWithLabel
                        label={"Introducing AVG"}
                        value={calculatedData?.in_AVERAGE ? calculatedData?.in_AVERAGE : 0}
                        labelsize={6}
                        boxsize={6}
                        textAlign={"right"} />
                    <TextBoxWithLabel
                        label={"ADJ AVG"}
                        value={calculatedData?.adj_AVERAGE ? calculatedData?.adj_AVERAGE : 0}
                        labelsize={6}
                        boxsize={6}
                        textAlign={"right"} />
                    <TextBoxWithLabel
                        label={"Season QTY"}
                        value={calculatedData?.season_QTY ? calculatedData?.season_QTY : 0}
                        labelsize={6}
                        boxsize={6}
                        textAlign={"right"} />
                    <TextBoxWithLabel
                        label={"Prom GR Rate/QTY"}
                        value={calculatedData?.prom_GROWTH_QTY ? calculatedData?.prom_GROWTH_QTY : 0}
                        labelsize={6}
                        boxsize={6}
                        textAlign={"right"} />
                </Col>
                <Col sm={12} md={4} className="mb-12-sm">
                    <TextBoxWithLabel
                        label={"Rolling AVG"}
                        value={calculatedData?.rl_AVG ? calculatedData?.rl_AVG : 0}
                        labelsize={6}
                        boxsize={6}
                        textAlign={"right"} />
                    <TextBoxWithLabel
                        label={"Last Month Sale"}
                        value={calculatedData?.lm_SALE ? calculatedData?.lm_SALE : 0}
                        labelsize={6}
                        boxsize={6}
                        textAlign={"right"} />
                    <TextBoxWithLabel
                        label={"Last Month OSD"}
                        value={calculatedData?.lm_OSD ? calculatedData?.lm_OSD : 0}
                        labelsize={6}
                        boxsize={6}
                        textAlign={"right"} />
                    <TextBoxWithLabel
                        label={"This Month Sale"}
                        value={calculatedData?.cm_SALE ? calculatedData?.cm_SALE : 0}
                        labelsize={6}
                        boxsize={6}
                        textAlign={"right"} />
                    <TextBoxWithLabel
                        label={"This Month OSD"}
                        value={calculatedData?.cm_OSD ? calculatedData?.cm_OSD : 0}
                        labelsize={6}
                        boxsize={6}
                        textAlign={"right"}
                    />
                </Col>
            </Row>
        </React.Fragment>
    )

}

export default ProductAutoOrderContent



const TextBoxWithLabel = (props) => {
    return (
        <Row className="mb-2">
            <Col sm={12} md={props.labelsize ? props.labelsize : 3} className="mb-4-sm">
                <Label>{props.label}</Label>
            </Col>
            <Col sm={12} md={props.boxsize ? props.boxsize : 9} className="mb-4-sm">
                <DPTextBoxforgrid
                    value={props.value}
                    disabled={true}
                    textAlign={props.textAlign ? props.textAlign : "left"}
                />
            </Col>
        </Row>
    )
}

